// extracted by mini-css-extract-plugin
export default {"table-main":"MapOrgsTable_table-main__-TkPo","loading":"MapOrgsTable_loading__L1rZL"};